import { Course } from './../../models/course';
import { CourseService } from './../../services/course.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LanguagesMap } from '../../const/common';

@Component({
  selector: 'app-courses-details',
  templateUrl: './courses-details.component.html',
  styleUrls: ['./courses-details.component.scss']
})
export class CoursesDetailsComponent implements OnInit {
  currentCourseId: string;
  currentCourse: Course = new Course();
  languagesMap = LanguagesMap;

  constructor(private route: ActivatedRoute,
              private courseService: CourseService) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.currentCourseId = params.get('id');
      this.courseService.getCourseById(this.currentCourseId).toPromise().then(res => {
        this.currentCourse = res;
      });
    });
  }

}
